import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProductImageComponent } from './product-image.component';

@NgModule({
  declarations: [ProductImageComponent],
  exports: [ProductImageComponent],
  imports: [CommonModule],
})
export class ProductImageModule {}
